export default "__VITE_ASSET__DK4U_0Uy__"